import Vue from 'vue';
// Set English locale (default is Chinese)
import locale from 'element-ui/lib/locale';
import english from 'element-ui/lib/locale/lang/en';
locale.use(english);
import { Alert, Autocomplete, Button, Checkbox, CheckboxGroup, Col, Collapse, CollapseItem, ColorPicker, Container, DatePicker, Dialog, Divider, Dropdown, DropdownMenu, DropdownItem, Form, FormItem, Header, Input, InputNumber, Loading, Main, Notification, MessageBox, Option, Pagination, Popover, Progress, Select, Tooltip, Switch, Radio, Row, Table, TableColumn, Tabs, TabPane, Tag, Tree, } from 'element-ui';
const components = [
    Alert,
    Autocomplete,
    Button,
    Checkbox,
    CheckboxGroup,
    Col,
    Collapse,
    CollapseItem,
    ColorPicker,
    Container,
    DatePicker,
    Dialog,
    Divider,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Form,
    FormItem,
    Header,
    Input,
    InputNumber,
    Main,
    MessageBox,
    Option,
    Pagination,
    Popover,
    Progress,
    Select,
    Tooltip,
    Switch,
    Radio,
    Row,
    Table,
    TableColumn,
    Tabs,
    TabPane,
    Tag,
    Tree,
];
for (const comp of components) {
    Vue.component(comp.name, comp);
}
Vue.use(Loading.directive);
Vue.prototype.$notify = Notification;
